import { useNavigate, useParams } from 'react-router-dom';
import { useCountry, useUpdateCountry, useTranslation } from '@/hooks';
import { CreateCountryRequest } from '@/types/model';
import CountryForm from '@/components/forms/CountryForm';
import Button from '@/components/ui/Button';

const EditCountry = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data: country, isLoading, isError, error } = useCountry(id || '');
  const updateCountryMutation = useUpdateCountry();

  const handleSuccess = async (data: CreateCountryRequest) => {
    if (!id) {
      return;
    }

    try {
      await updateCountryMutation.mutateAsync({ id, data });
      console.log('Country updated successfully');
      navigate('/content/countries');
    } catch (err) {
      console.error('Update country error', err);
      throw err;
    }
  };

  const handleCancel = () => {
    navigate('/content/countries');
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
          </div>
        </div>
      </div>
    );
  }

  if (isError || !country) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-red-50 border border-red-200 rounded-md p-4">
            <p className="text-sm text-red-600">
              {error instanceof Error ? error.message : t.errors.loadingError}
            </p>
            <div className="mt-4">
              <Button variant="outline" onClick={handleCancel}>
                {t.buttons.cancel}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <CountryForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          initialData={country}
          isEdit
          isSubmitting={updateCountryMutation.isPending}
        />
      </div>
    </div>
  );
};

export default EditCountry;
